var map = {
	"./pages/about/about.module": [
		"./src/app/pages/about/about.module.ts",
		"default~pages-about-about-module~pages-auth-login-login-module~pages-category-category-module~pages-~a25d9798",
		"pages-about-about-module"
	],
	"./pages/all-quiz/all-quiz.module": [
		"./src/app/pages/all-quiz/all-quiz.module.ts",
		"pages-all-quiz-all-quiz-module"
	],
	"./pages/auth/login/login.module": [
		"./src/app/pages/auth/login/login.module.ts",
		"default~pages-about-about-module~pages-auth-login-login-module~pages-category-category-module~pages-~a25d9798",
		"pages-auth-login-login-module"
	],
	"./pages/bookmark/bookmark.module": [
		"./src/app/pages/bookmark/bookmark.module.ts",
		"pages-bookmark-bookmark-module"
	],
	"./pages/category/category.module": [
		"./src/app/pages/category/category.module.ts",
		"default~pages-about-about-module~pages-auth-login-login-module~pages-category-category-module~pages-~a25d9798",
		"common",
		"pages-category-category-module"
	],
	"./pages/cert/cert.module": [
		"./src/app/pages/cert/cert.module.ts",
		"default~pages-about-about-module~pages-auth-login-login-module~pages-category-category-module~pages-~a25d9798",
		"common",
		"pages-cert-cert-module"
	],
	"./pages/contact/contact.module": [
		"./src/app/pages/contact/contact.module.ts",
		"default~pages-about-about-module~pages-auth-login-login-module~pages-category-category-module~pages-~a25d9798",
		"common",
		"pages-contact-contact-module"
	],
	"./pages/exam-result/exam-result.module": [
		"./src/app/pages/exam-result/exam-result.module.ts",
		"common",
		"pages-exam-result-exam-result-module"
	],
	"./pages/home/home.module": [
		"./src/app/pages/home/home.module.ts",
		"default~pages-about-about-module~pages-auth-login-login-module~pages-category-category-module~pages-~a25d9798",
		"common",
		"pages-home-home-module"
	],
	"./pages/profile/profile-edit/profile-edit.module": [
		"./src/app/pages/profile/profile-edit/profile-edit.module.ts",
		"default~pages-about-about-module~pages-auth-login-login-module~pages-category-category-module~pages-~a25d9798",
		"common",
		"pages-profile-profile-edit-profile-edit-module"
	],
	"./pages/profile/profile.module": [
		"./src/app/pages/profile/profile.module.ts",
		"default~pages-about-about-module~pages-auth-login-login-module~pages-category-category-module~pages-~a25d9798",
		"common",
		"pages-profile-profile-module"
	],
	"./pages/quiz-detail/quiz-detail.module": [
		"./src/app/pages/quiz-detail/quiz-detail.module.ts",
		"default~pages-about-about-module~pages-auth-login-login-module~pages-category-category-module~pages-~a25d9798",
		"default~pages-quiz-detail-quiz-detail-module~pages-quiz-quiz-module",
		"pages-quiz-detail-quiz-detail-module"
	],
	"./pages/quiz/quiz.module": [
		"./src/app/pages/quiz/quiz.module.ts",
		"default~pages-about-about-module~pages-auth-login-login-module~pages-category-category-module~pages-~a25d9798",
		"default~pages-quiz-detail-quiz-detail-module~pages-quiz-quiz-module",
		"common",
		"pages-quiz-quiz-module"
	],
	"./pages/term/term.module": [
		"./src/app/pages/term/term.module.ts",
		"pages-term-term-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;